<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="广告标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入广告标题" />
      </a-form-model-item>
      <!-- <a-form-model-item label="跳转地址" prop="url" >
        <a-input v-model="form.url" placeholder="请输入跳转地址" />
      </a-form-model-item> -->
      <a-form-model-item label="广告图片" prop="image" >
        <file-upload
          type="image"
          :defaultList="form.imageArr"
          :count="form.imageCount || 1"
          :imgSize="'690*300'"
          @input="getImg($event, 'image')"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="是否首页弹框展示" prop="isDisplay" >
        <a-radio-group v-model="form.isDisplay">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="类型 " prop="type" >
        <a-select v-model="form.type">
          <a-select-option :value="3">轮播图</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="链接类型" prop="linkType" >

        <a-select v-model="form.linkType" @change="changeType">
          <a-select-option :value="0">不跳转</a-select-option>
          <a-select-option :value="1">外链</a-select-option>
          <a-select-option :value="2">人物访谈</a-select-option>
          <a-select-option :value="3">听课实录</a-select-option>
          <a-select-option :value="4">行业干货</a-select-option>
<!--          <a-select-option :value="5">课程详情(健身课程)</a-select-option>-->
<!--          <a-select-option :value="6">门店详情</a-select-option>-->
<!--          <a-select-option :value="7">直播</a-select-option>-->
<!--          <a-select-option :value="8">开通会员</a-select-option>-->
<!--          <a-select-option :value="9">闲橙健康</a-select-option>-->
<!--          <a-select-option :value="10">闲橙优选</a-select-option>-->
<!--          <a-select-option :value="11">兑换商城</a-select-option>-->
<!--          <a-select-option :value="12">动态详情(视频)</a-select-option>-->
<!--          <a-select-option :value="13">课程详情(学院课程)</a-select-option>-->
<!--          <a-select-option :value="14">课程详情(创作者视频)</a-select-option>-->
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="外链地址" prop="link" v-if="form.linkType == 1">
        <a-input  v-model="form.link" placeholder="请输入外链地址" />
      </a-form-model-item>
      <a-form-model-item label="人物访谈" prop="link" v-if="form.linkType == 2">
        <a-select
          v-model="form.link"
          show-search
          :filter-option="false"
          :not-found-content="selectLoading ? '加载中...' : '暂无数据'"
          @search="handleTeacherSearch"
          @focus="loadTeacherList"
        >
          <a-select-option v-for="item in teacherList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="听课实录" prop="link" v-if="form.linkType == 3">
        <a-select
          v-model="form.link"
          show-search
          :filter-option="false"
          :not-found-content="selectLoading ? '加载中...' : '暂无数据'"
          @search="handleOpenCourseSearch"
          @focus="loadOpenCourseList"
        >
          <a-select-option v-for="item in openCourseList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="行业干货" prop="link" v-if="form.linkType == 4">
        <a-select
          v-model="form.link"
          show-search
          :filter-option="false"
          :not-found-content="selectLoading ? '加载中...' : '暂无数据'"
          @search="handleInfoSearch"
          @focus="loadInfoList"
        >
          <a-select-option v-for="item in infoList" :value="item.id" :key="item.id">{{item.content || item.title || item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="课程详情" prop="link" v-if="form.linkType == 5">-->
<!--        <a-select v-model="form.link">-->
<!--          <a-select-option v-for="item in courseList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="门店详情" prop="link" v-if="form.linkType == 6">-->
<!--        <a-select v-model="form.link">-->
<!--          <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="直播" prop="link" v-if="form.linkType == 7">-->
<!--&lt;!&ndash;        <a-select v-model="form.link">&ndash;&gt;-->
<!--&lt;!&ndash;          <a-select-option v-for="item in noticeList" :value="item.id">{{item.title}}</a-select-option>&ndash;&gt;-->
<!--&lt;!&ndash;        </a-select>&ndash;&gt;-->
<!--        <a-input v-model="form.url" placeholder="请输入跳转地址" />-->

<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="开通会员" prop="link" v-if="form.linkType == 8">-->
<!--        <a-select v-model="form.link">-->
<!--          <a-select-option v-for="item in memberList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="闲橙健康" prop="link" v-if="form.linkType == 9">-->
<!--        <a-select v-model="form.link"  show-search-->
<!--                  :filter-option="filterOption">-->
<!--          <a-select-option v-for="item in healthList" :value="item.id" :key="item.id">{{item.goodsName}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="闲橙优选" prop="link" v-if="form.linkType == 10">-->
<!--        <a-select v-model="form.link"  show-search-->
<!--                  :filter-option="filterOption">-->
<!--          <a-select-option v-for="item in preferredList" :value="item.id" :key="item.id">{{item.goodsName}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="兑换商城" prop="link" v-if="form.linkType == 11">-->
<!--        <a-select v-model="form.link"  show-search-->
<!--                  :filter-option="filterOption">-->
<!--          <a-select-option v-for="item in convertList" :value="item.id" :key="item.id">{{item.goodsName}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->

<!--      <a-form-model-item label="动态详情(视频)" prop="link" v-if="form.linkType == 12">-->
<!--        <a-select v-model="form.link">-->
<!--          <a-select-option v-for="item in articleVideoList" :value="item.id" :key="item.id">{{item.content}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="课程详情(学院课程)" prop="link" v-if="form.linkType == 13">-->
<!--        <a-select v-model="form.link">-->
<!--          <a-select-option v-for="item in courseCollegeList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="课程详情(创作者课程)" prop="link" v-if="form.linkType == 14">-->
<!--        <a-select v-model="form.link">-->
<!--          <a-select-option v-for="item in courseOriginatorList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->


<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBanner, addBanner, updateBanner } from '@/api/index/banner'
import {guid} from "@/utils/ruoyi";
import {listInfo} from '@/api/dynamics/info'
import {listTeacher} from '@/api/teacher/teacher'
import {listOpenCourse} from '@/api/openCourse/openCourse'
import {listChallenge} from "@/api/challenge/challenge";
import {listCourse} from "@/api/course/course";
// 以下API函数如果不存在，相关功能将被禁用
// import {listGoods} from "@/api/goods/goods";
// import {listShop} from "@/api/shop/shop";
// import {listMemberInfo} from "@/api/member/memberInfo";
// import {listGoodsInfo} from "@/api/goods/goodsInfo";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    // 以下组件已注释，这些是API函数，不是Vue组件
    // listGoods,
    // listChallenge,
    // listCourse,
    // listShop,
    // listMemberInfo,
    // listInfo,
  },
  data () {
    return {
      submitLoading: false,
      selectLoading: false,
      formTitle: '',
      teacherKeyword: '',
      openCourseKeyword: '',
      infoKeyword: '',
      teacherList: [],
      openCourseList: [],
      infoList: [],
      //商品详情
      goodList:[],
      // 动态详情(图文)
      articleList:[],
      // 动态详情(视频)
      articleVideoList:[],
      // 挑战赛详情
      challengeList:[],
      // 课程详情(会员课程)
      courseList:[],
      // 课程详情(学院课程)
      courseCollegeList:[],
      // 课程详情(创作者课程)
      courseOriginatorList:[],
      // 门店详情
      shopList:[],
      // 直播 暂无

      // 开通会员
      memberList:[],
      // 闲橙健康
      healthList:[],
      // 闲橙优选
      preferredList:[],
      // 兑换商城
      convertList:[],
      // 表单参数
      form: {
        id: null,

        url: null,
        title: null,

        image: null,
        imageCount:1,
        imageArr:[],

        isDisplay: null,

        type: null,
        linkType: null,
        link: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '广告标题不能为空', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '广告图片不能为空', trigger: 'blur' }
        ],
        isDisplay: [
          { required: true, message: '是否首页弹框展示不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型 不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initList()
  },
  activated() {
    this.initList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    filterOption(input, option) {
      this.valGuiGe = input
      this.form.specIds = input

      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    changeType(){
      this.form.link = null
      this.loadLinkDataByType(this.form.linkType)
    },
    loadLinkDataByType(linkType) {
      if (linkType === 2) {
        this.loadTeacherList()
      } else if (linkType === 3) {
        this.loadOpenCourseList()
      } else if (linkType === 4) {
        this.loadInfoList()
      }
    },
    handleTeacherSearch(value) {
      this.teacherKeyword = value || ''
      this.loadTeacherList()
    },
    handleOpenCourseSearch(value) {
      this.openCourseKeyword = value || ''
      this.loadOpenCourseList()
    },
    handleInfoSearch(value) {
      this.infoKeyword = value || ''
      this.loadInfoList()
    },
    loadTeacherList() {
      this.selectLoading = true
      listTeacher({ name: this.teacherKeyword }).then(res => {
        this.teacherList = res.data || []
      }).finally(() => {
        this.selectLoading = false
      })
    },
    loadOpenCourseList() {
      this.selectLoading = true
      listOpenCourse({ name: this.openCourseKeyword }).then(res => {
        this.openCourseList = res.data || []
      }).finally(() => {
        this.selectLoading = false
      })
    },
    loadInfoList() {
      this.selectLoading = true
      listInfo({ title: this.infoKeyword ,isRecommend:1}).then(res => {
        this.infoList = res.data || []
      }).finally(() => {
        this.selectLoading = false
      })
    },
    initList(){
      console.log('开始初始化列表数据')

      // // 动态详情(图文)
      // listInfo({imageVideo:1}).then(res=>{
      //   this.articleList = res.data || []
      //   console.log('图文动态列表加载成功:', this.articleList.length)
      // }).catch(err => {
      //   console.warn('图文动态列表加载失败', err)
      //   this.articleList = []
      // })

      // // 动态详情(视频)
      // listInfo({imageVideo:2}).then(res=>{
      //   this.articleVideoList = res.data || []
      //   console.log('视频动态列表加载成功:', this.articleVideoList.length)
      // }).catch(err => {
      //   console.warn('视频动态列表加载失败', err)
      //   this.articleVideoList = []
      // })

      // 挑战赛详情
      // console.log('开始加载挑战赛列表')
      // listChallenge({}).then(res=>{
      //   console.log('挑战赛列表加载成功:', res)
      //   this.challengeList = res.data || []
      //   console.log('挑战赛列表数量:', this.challengeList.length)
      // }).catch(err => {
      //   console.error('挑战赛列表加载失败:', err)
      //   this.challengeList = []
      // })
      //
      // // 课程详情(会员课程)
      // listCourse({type:0}).then(res=>{
      //   this.courseList = res.data || []
      //   console.log('会员课程列表加载成功:', this.courseList.length)
      // }).catch(err => {
      //   console.warn('会员课程列表加载失败', err)
      //   this.courseList = []
      // })
      //
      // // 课程详情(学院课程)
      // listCourse({type:1}).then(res=>{
      //   this.courseCollegeList = res.data || []
      //   console.log('学院课程列表加载成功:', this.courseCollegeList.length)
      // }).catch(err => {
      //   console.warn('学院课程列表加载失败', err)
      //   this.courseCollegeList = []
      // })
      //
      // // 课程详情(创作者课程)
      // listCourse({type:2}).then(res=>{
      //   this.courseOriginatorList = res.data || []
      //   console.log('创作者课程列表加载成功:', this.courseOriginatorList.length)
      // }).catch(err => {
      //   console.warn('创作者课程列表加载失败', err)
      //   this.courseOriginatorList = []
      // })

      // 以下API函数未导入，相关功能暂时禁用
      // 如果需要使用，请取消注释并确保API已正确导入

      // // 商品详情
      // if (listGoodsInfo) {
      //   listGoodsInfo({status:1}).then(res=>{
      //     this.goodList = res.data || []
      //   }).catch(err => {
      //     console.warn('商品列表加载失败', err)
      //     this.goodList = []
      //   })
      // }
      //
      // // 门店详情
      // if (listShop) {
      //   listShop().then(res=>{
      //     this.shopList = res.data || []
      //   }).catch(err => {
      //     console.warn('门店列表加载失败', err)
      //     this.shopList = []
      //   })
      // }

      // // 开通会员
      // if (listMemberInfo) {
      //   listMemberInfo().then(res=>{
      //     this.memberList = res.data || []
      //   }).catch(err => {
      //     console.warn('会员列表加载失败', err)
      //     this.memberList = []
      //   })
      // }
      //
      // // 闲橙健康
      // if (listGoodsInfo) {
      //   listGoodsInfo({type:3,status:1}).then(res=>{
      //     this.healthList = res.data || []
      //   }).catch(err => {
      //     console.warn('闲橙健康列表加载失败', err)
      //     this.healthList = []
      //   })
      // }
      //
      // // 闲橙优选
      // if (listGoodsInfo) {
      //   listGoodsInfo({type:2,status:1}).then(res=>{
      //     this.preferredList = res.data || []
      //   }).catch(err => {
      //     console.warn('闲橙优选列表加载失败', err)
      //     this.preferredList = []
      //   })
      // }
      //
      // // 兑换商城
      // if (listGoodsInfo) {
      //   listGoodsInfo({type:1,status:1}).then(res=>{
      //     this.convertList = res.data || []
      //   }).catch(err => {
      //     console.warn('兑换商城列表加载失败', err)
      //     this.convertList = []
      //   })
      // }

    },

    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(",") === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          if (imgArr.length) {
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        url: null,
        title: null,
        image: null,
        imageArr: [],
        imageCount: 1,
        isDisplay: null,
        type: null,
        linkType: null,
        link: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.open = true
      this.formType = 1
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBanner({"id":id}).then(response => {
        this.form = response.data
        this.loadLinkDataByType(this.form.linkType)
        this.open = true
        this.formTitle = '修改'

        // 确保 imageCount 存在
        if (!this.form.imageCount) {
          this.form.imageCount = 1
        }

        // 处理图片数据回显
        let that = this
        this.form.imageArr = []
        if (this.form.image) {
          this.form.imageArr.push({
            uid: guid(8, 10),
            name: that.form.image,
            status: 'done',
            halfUrl: that.form.image,
            url: that.form.image,
            path: that.form.image
          })
        }
      }).catch(error => {
        console.error('获取广告详情失败:', error)
        this.$message.error('获取广告详情失败，请稍后重试')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBanner(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBanner(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
